module.exports = __webpack_public_path__ + "img/HEB_MOBILE.26fbaee8.png";